import { theme } from 'aimo-ui';
import MenuItem from 'components/common/MenuItem';
import PermitAvailability from 'components/longTermParking/waitingList/PermitAvailability';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppConfigStore } from 'stores/appConfigStore';
import { usePermitStore } from 'stores/permitStore';
import { ColumnWithMargins } from 'styles/ContainerStyles';
import { Pmc } from 'types/generatedSchemaTypes';
import {
  getEffectiveVisibility,
  initSalesOrderPmcPurchase,
  isPmcAvailable,
} from 'utils/permitUtils';
import { useUiStore } from 'stores/uiStore';

type NonReservedPermitsProps = {
  priceLabel: string;
  pmc: Pmc;
  testID?: string;
  handleNavigate: (
    pmcId: string,
    notAvailable: boolean,
    pmcIsLockedByMemberGroup?: boolean
  ) => void;
  memberGroupName?: string;
  pmcIsLockedForTheCustomer?: boolean;
  pmcIsInsideALockedMemberGroup?: boolean;
  disabled?: boolean;
};

const NonReservedPermits = ({
  priceLabel,
  pmc,
  testID,
  handleNavigate,
  memberGroupName,
  pmcIsLockedForTheCustomer,
  pmcIsInsideALockedMemberGroup,
  disabled,
}: NonReservedPermitsProps) => {
  const { t } = useTranslation();
  const setSelectedPmc = usePermitStore((state) => state.setSelectedPmc);
  const { pmcId, name, visibility } = pmc;

  const { permitNotAvailable: notAvailable } = isPmcAvailable(pmc);

  const Availability = useMemo(
    () => (
      <PermitAvailability
        pmc={pmc}
        pmcIsLockedForTheCustomer={pmcIsLockedForTheCustomer}
        pmcIsInsideALockedMemberGroup={pmcIsInsideALockedMemberGroup}
      />
    ),
    [pmc, pmcIsLockedForTheCustomer, pmcIsInsideALockedMemberGroup]
  );
  const effectiveVisibility = getEffectiveVisibility(
    pmcIsLockedForTheCustomer,
    visibility,
    pmcIsInsideALockedMemberGroup
  );

  return (
    <ColumnWithMargins mb={20}>
      <MenuItem
        testID={testID}
        menuLabel={name ?? ''}
        withArrow
        noBorder
        disabled={notAvailable || disabled}
        subtitle={
          effectiveVisibility === 'LOCKED'
            ? t('permit.unlockPMC.unlockToSeePrice')
            : priceLabel
        }
        onPress={() => {
          if (pmcIsLockedForTheCustomer) {
            setSelectedPmc(pmc);
            handleNavigate(
              pmcId ?? '',
              notAvailable,
              pmcIsLockedForTheCustomer
            );
          } else if (
            !pmcIsInsideALockedMemberGroup &&
            visibility === 'LOCKED'
          ) {
            setSelectedPmc(pmc);
            initSalesOrderPmcPurchase(pmc);
            useAppConfigStore.getState().setNavigateType('ParkingZonePermit');
            useUiStore.getState().setSheetModal('unlockPmc');
          } else {
            setSelectedPmc(pmc);
            handleNavigate(pmcId ?? '', notAvailable);
          }
        }}
        background={theme.colors.gray50}
        bottomPillText={memberGroupName}
        visibility={effectiveVisibility ?? undefined}
        rightComponent={Availability}
      />
    </ColumnWithMargins>
  );
};

export default NonReservedPermits;
